// Step 24 — execution findings surface.
//
// Reuses the Step 19 AIFindingCard verbatim. Findings come from
// `executionFindingsFromSituation` — a projection over data three
// existing endpoints already returned. No new taxonomy: findings use
// the same KIND values (RISK, PREPAREDNESS, CONTRACT_REVIEW,
// CONTRACT_UNCERTAINTY, ACTION_PENDING, BUYER_SIGNAL) the rest of the
// AI workspace uses.

import AIFindingCard from "../intelligence/AIFindingCard";
import { AIEmpty, AISection } from "../AIPrimitives";
import { executionFindingsFromSituation } from "./helpers";

export default function AIExecutionFindings({
  actions,
  contracts,
  situation,
  workspaceId,
  now,
}) {
  const findings = executionFindingsFromSituation({
    actions,
    contracts,
    situation,
    now,
  });
  if (findings.length === 0) {
    return (
      <AISection title="Fynd">
        <AIEmpty
          title="Inga öppna fynd i genomförandeläget"
          hint={
            "Fynd bygger på deterministiska poster från risker, " +
            "beredskapsgap, kontraktsstatus och åtgärder."
          }
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Fynd"
      right={
        <span className="qai-page-section-hint">
          {findings.length} post{findings.length === 1 ? "" : "er"}
        </span>
      }
    >
      <div className="qai-attention-queue">
        {findings.map((f) => (
          <AIFindingCard key={f.key} finding={f} workspaceId={workspaceId} />
        ))}
      </div>
    </AISection>
  );
}
